module.exports = __webpack_public_path__ + "static/media/image4.fe4e273a.jpeg";